import { Button, ComponentBase, Div, Span } from "@tblabs/truffle";


export class Menu extends Div
{
    constructor(menuItems: Record<string, () => void>, private onClose?: () => void)
    {
        super("menu-popup");

        this.Append(
            ...Object.entries(menuItems)
                .map(([label, action]) =>
                {
                    const span = new Span(label).Class("menu-item")
                        .OnClick(() =>
                        {
                            document.removeEventListener("click", this.DocumentClick);
                            this.RemoveSelf();
                            this.onClose?.();
                            action();
                        });
                    return span;
                })
        );

        document.addEventListener("click", this.DocumentClick, { once: true });
    }

    // ☢️ UWAGA! TO MA BYĆ FUNKCJA (NIE METODA) JEŚLI ZROBIMY Z TEGO METODĘ TO NIE DZIAŁA document.removeEventListener. 
    // NIE WAŻNE CZY DO TEJ METODY PRZEKAŻEMY WSKAŹNIK NA METODE, WYWOŁANIE FUNKCJI STRZAŁKOWEJ CZY ZROBIMY .bind(this). 
    // KAŻDA TA OPCJA NIE DZIAŁA CO POTEM POWODUJE PROBLEMY Z RemoveSelf BO JEST TRACONY KONTEKST DO this. 
    // MOŻNA OD BIEDY WSPOMÓC SIĘ POMOCNICZĄ FLAGĄ ALE TAK KOD JEST CZYSTSZY CHOĆ WYGLĄDA KRETYŃSKO.
    private DocumentClick = () =>
    {
        this.RemoveSelf();
        this.onClose?.();
    };
}


export class ContextMenu extends Div
{
    constructor(menuItems: Record<string, () => void>, activator: ComponentBase<any> = new Button("⋮").RemoveClass("uk-button").Class("menu-button"))
    {
        super();

        this.Append(
            activator.OnClick(_ =>
            {
                _.Disabled()

                this.Append(
                    new Menu(menuItems, () =>
                    {
                        _.Enabled()
                    }))
            }),
        );
    }
}